import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps } from '~src/app/utils/ConnectUtils';
import { deleteContentsAction } from '~src/spacesPlatform/actions/DeleteContentAction';
import { ExplorableItemType } from '~src/spacesPlatform/models/ContentType';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { ContentDetailSection } from './ContentDetailSection';


interface DeleteContentSectionOwnProps {
  readonly actionMessage: string;
  readonly content: IContentInfo<ExplorableItemType>;
}

interface DeleteContentDispatchProps {
  readonly deleteContent: (items: IContentInfo<ExplorableItemType>[]) => void;
}

export type DeleteContentSectionProps = DeleteContentSectionOwnProps & DeleteContentDispatchProps;

export function DeleteContentSection(props: DeleteContentSectionProps): JSX.Element {
  return (
    <ContentDetailSection
      header={''}
      testId={'delete'}
      detail={''}
      isActionAllowed={true}
      action={
        <div style={{ marginTop: TabStyles.Spacing.DefaultSpace }}>
          <ButtonWidget
            buttonType={ButtonType.Destructive}
            children={props.actionMessage}
            testId={'delete-content'}
            handleClick={() => {
              props.deleteContent([props.content]);
            }}
          />
        </div>
      }
    />
  );
}

const mapDispatchToProps: MapDispatchToProps<DeleteContentDispatchProps> = (dispatch) => bindActionCreators({
  deleteContent: deleteContentsAction,
}, dispatch);

export const ConnectedDeleteContentSection: React.ComponentClass<DeleteContentSectionOwnProps> =
  connect(undefined, mapDispatchToProps)(DeleteContentSection);
